/**
 * index.js
 * --------
 * Entry point for the React application.
 *
 * Mounts the CawoodAssessment component into the div rendered by the
 * WordPress shortcode. The mount div ID must match the id set in
 * cawood-assessment.php — both use "cawood-assessment-mount".
 *
 * If the mount element is not found on the page (i.e. the shortcode
 * is not present), the app does nothing and no error is thrown.
 *
 * Connected files:
 *   - CawoodAssessment.jsx     root component
 *   - cawood-assessment.php    renders the mount div via the shortcode
 */

import React from "react";
import ReactDOM from "react-dom/client";
import CawoodAssessment from "./CawoodAssessment.jsx";

// Target the mount div rendered by the WordPress shortcode
const mountElement = document.getElementById("cawood-assessment-mount");

// Only mount if the element exists on this page
if (mountElement) {
  const root = ReactDOM.createRoot(mountElement);
  root.render(
    <React.StrictMode>
      <CawoodAssessment />
    </React.StrictMode>
  );
}
